(() => {
  document.querySelectorAll('[data-es-shell]').forEach((root) => {
    let activeDrawer = null;
    let returnFocus = null;

    const closeDrawer = () => {
      if (!activeDrawer) return;
      activeDrawer.hidden = true;
      activeDrawer = null;
      document.body.style.overflow = '';
      root.querySelectorAll('[data-drawer-open]').forEach((button) => button.setAttribute('aria-expanded', 'false'));
      returnFocus?.focus();
    };

    root.querySelectorAll('[data-drawer-open]').forEach((button) => {
      button.addEventListener('click', () => {
        closeDrawer();
        returnFocus = button;
        activeDrawer = root.querySelector(`[data-drawer="${button.dataset.drawerOpen}"]`);
        if (!activeDrawer) return;
        activeDrawer.hidden = false;
        button.setAttribute('aria-expanded', 'true');
        document.body.style.overflow = 'hidden';
        activeDrawer.querySelector('[data-drawer-close][aria-label]')?.focus();
      });
    });

    root.querySelectorAll('[data-drawer-close]').forEach((element) => element.addEventListener('click', closeDrawer));
    root.addEventListener('keydown', (event) => { if (event.key === 'Escape') closeDrawer(); });
  });
})();
